import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePublicLayout } from "@/contexts/layout-context";
import { SeoManager } from "@/components/seo-manager";

export default function NotFound() {
  usePublicLayout({});

  return (
    <>
    <SeoManager meta={{ title: "Pagina non trovata | Universo Oro", description: "La pagina richiesta non esiste.", canonical: "", noIndex: true }} />
    <div className="min-h-screen w-full flex items-center justify-center bg-background">
      <div className="text-center px-4">
        <h1 className="text-8xl font-bold text-primary mb-4 font-serif">404</h1>
        <p className="text-2xl text-foreground mb-2">Pagina Non Trovata</p>
        <p className="text-muted-foreground mb-4">La pagina che stai cercando non esiste o è stata spostata.</p>
        
        
        <Link href="/">
          <Button size="lg" data-testid="button-home">
            <ArrowLeft className="h-5 w-5 mr-2" />
            Vai subito alla Home
          </Button>
        </Link>
      </div>
    </div>
    </>
  );
}
